import React from 'react';
import { compose } from 'ramda';
import { RouteComponentProps } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Animation from 'components/Animation/Animation';
import RouterProvider from 'components/RouterProvider/RouterProvider';

const { withRouter } = RouterProvider;

interface Props {
  children: React.ReactNode;
  hasValues: boolean;
  isLoaded: boolean;
  history: RouteComponentProps['history'];
  withLoader?: boolean;
  text?: string;
  type: 'no-results' | 'no-reports' | 'we-changing';
  isAnimated?: boolean;
  width?: string;
  height?: string;
}

const AnimatedPlaceholder = ({
  children,
  isLoaded = false,
  hasValues,
  withLoader = false,
  text,
  type = 'no-results',
  isAnimated = true,
  width = '400px',
  height = '400px',
}: Props) => {
  if (!isLoaded && withLoader && !hasValues) {
    return (
      <Grid container justify="center">
        <CircularProgress />
      </Grid>
    );
  }
  if (isLoaded && !hasValues) {
    return (
      <Grid container justify="center" alignItems="center">
        <Animation
          width={width}
          height={height}
          isAnimated={isAnimated}
          text={text}
          type={type}
        />
      </Grid>
    );
  }
  return (
    <>
      {!isLoaded && withLoader && (
        <Grid container justify="center">
          <CircularProgress />
        </Grid>
      )}
      {children}
    </>
  );
};

export default compose(withRouter)(AnimatedPlaceholder);
